
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMessagesIec as ObiMessagesIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-messages-iec.js';
 
 
 

 
 export const ObiMessagesIec = createComponent({
   react: React,
   tagName: 'obi-messages-iec',
   elementClass: ObiMessagesIecElement,
   events: {
     
   }
  });
 
 